// client/src/hooks/useSupportAccess.js
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';
import useAlert from './useAlert';

const QUERY_KEY = ['acessoSuporte'];

// 🔹 Concessão de acesso de suporte ativa do tenant logado (ou null)
export const useSupportAccessStatus = () => {
    return useQuery({
        queryKey: QUERY_KEY,
        queryFn: async () => {
            const { data } = await api.get('/acesso-suporte');
            return data.data;
        },
    });
};

// 🔹 Habilita acesso de suporte pro tenant inteiro por N horas (1/4/24)
export const useGrantSupportAccess = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert();
    return useMutation({
        mutationFn: (duracaoHoras) => api.post('/acesso-suporte', { duracaoHoras }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: QUERY_KEY });
            setAlert('Acesso de suporte habilitado.', 'success');
        },
        onError: (err) => setAlert(err.response?.data?.error || err.response?.data?.message || 'Erro ao habilitar acesso de suporte.', 'danger'),
    });
};

// 🔹 Revoga imediatamente o acesso de suporte ativo do tenant logado
export const useRevokeSupportAccess = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert();
    return useMutation({
        mutationFn: () => api.post('/acesso-suporte/revogar'),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: QUERY_KEY });
            setAlert('Acesso de suporte revogado.', 'success');
        },
        onError: (err) => setAlert(err.response?.data?.error || err.response?.data?.message || 'Erro ao revogar acesso de suporte.', 'danger'),
    });
};
